import { Members } from 'components';

const MembersPage = () => {
	return <Members />;
};

export default MembersPage;
